import { useTranslation } from "react-i18next";
import { FooterWrapper, FooterText, FooterLinks } from "./Footer.styles";
import { APP_CONFIG } from "../../config";
import { Link } from "../../components/ui/Link/Link";

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterText>
        &copy; {currentYear} {APP_CONFIG.APP_NAME}.{" "}
        {t("common:all_rights_reserved")}
      </FooterText>
      <FooterLinks>
        <Link to="/pricing">{t("common:pricing")}</Link>
        <Link to="/terms">{t("common:terms")}</Link>
        <Link to="/privacy">{t("common:privacy")}</Link>
      </FooterLinks>
    </FooterWrapper>
  );
};
